
export const environment = {
  production: true,
  apiUrl: "https://prd-api.digitopayoficial.com.br/api",
  isShowNewScreen: false
};
